import { AuthenticationRepository } from '../repositories/AuthenticationRepository'
import { useAuthenticationStore } from '../../presentation/stores/useAuthenticationStore'
import { serviceLocator } from '@/utils/providers/serviceLocator'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'

export async function renewTokenCase() {
  const newRepository = serviceLocator.getService<AuthenticationRepository>('AuthenticationService')
  const authenticationStore = useAuthenticationStore()
  const { data } = await useQuery({
    fetcher: async () => await newRepository?.renewToken(),
    key: 'renewToken',
    filterData: JSON.stringify(''),
    skipCaching: true
  })
  if (data.value?.error) return
  localStorage.setItem('accessToken', data.value.accessToken)
  localStorage.setItem('refreshToken', data.value.refreshToken)
  authenticationStore.setAuthenticationData()
  return true
}
